import { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { SetupState, StorageKeys } from '../../../api/constants';
import * as api from '../../../api/setupServices';
import { useErrorContext } from '../../../errorHandler/context/ErrorContext';
import { type ApiError, FatalError } from '../../../errorHandler/errors';
import { getPortalUrl } from '../../../utils/utils';
import { STEPS } from '../../constants';

const TRANSLATION_ROOT = `setup.${STEPS.SETUP_COMPLETE}.content`;

const SetupComplete = () => {
  const { emitError } = useErrorContext();

  useEffect(() => {
    const setupState = sessionStorage.getItem(StorageKeys.TENANT_SETUP_STATE);
    console.log('[Setup Complete] Setup State: ', setupState);

    async function completeSetup() {
      try {
        await api.sendTenantSetupCompleteRequest(false);
        sessionStorage.setItem(StorageKeys.TENANT_SETUP_STATE, SetupState.COMPLETED);
        localStorage.clear();
        sessionStorage.clear();
      } catch (e) {
        // If the complete setup call fails, show a full page error.
        emitError(new FatalError(e as ApiError));
      }
    }

    if (setupState === SetupState.STARTED) {
      void completeSetup();
    }
  }, [emitError]);

  return (
    <>
      <p style={{ marginBottom: '8.13rem' }}>
        <Trans i18nKey={`${TRANSLATION_ROOT}.description`} />
        <a
          href={getPortalUrl()}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontWeight: 'bold' }}
        >
          {window.location.host}
        </a>
      </p>
      <p>
        <Trans i18nKey={`${TRANSLATION_ROOT}.description2`} />
      </p>
    </>
  );
};

export default SetupComplete;
